import cx from 'classnames';
import {type FC, memo, type ReactNode} from 'react';
import {CardDesignNavigator} from '~/common/FabricInvitation/EventCreateDesign/components/CardDesignNavigator/CardDesignNavigator';
import {Sections} from '~/common/FabricInvitation/EventCreateDesign/constants';
import {EnvelopeProvider} from '../contexts/EnvelopeContext';
import {CardEnvelopeTemplate} from './CardEnvelopeTemplate/CardEnvelopeTemplate';
import {CardTemplate} from './CardTemplate';
import {DesignContainer} from './DesignContainer/DesignContainer';
import './EventCreateContent.sass';

interface EventCreateContentProps {
  isDesktop: boolean;
  // biome-ignore lint/style/useNamingConvention: allow invalid naming
  Section: FC<{children?: ReactNode}>;
  currentSection: string;
}

export const EventCreateContent: FC<EventCreateContentProps> = memo(
  ({isDesktop, Section, currentSection}) => {
    const isCurrentSectionInEnvelope = [Sections.ENVELOPE_LINER].includes(currentSection);

    return (
      <EnvelopeProvider>
        <div
          className={cx(
            'im-event-create-design__content',
            'event-create-design__content',
            'preview-create-design__content',
            'fabric-refactor__event-create-design__content',
            {
              'show-tooltip-card-design': currentSection === 'card_design',
            },
            currentSection
          )}
        >
          {isDesktop && (
            <div className="card-design-navigator__desktop__buttons_wrapper">
              <CardDesignNavigator vertical />
            </div>
          )}
          <DesignContainer className={currentSection}>
            <CardEnvelopeTemplate hideEnvelope={isCurrentSectionInEnvelope}>
              <CardTemplate isCurrentSectionInEnvelope={isCurrentSectionInEnvelope} />
            </CardEnvelopeTemplate>
            <Section />
          </DesignContainer>
        </div>
      </EnvelopeProvider>
    );
  }
);
